module.exports = __webpack_public_path__ + "static/img/px-banner.72f65d61.png";